// // TestRunList.tsx
// import { Checkbox, List, theme } from 'antd'
// import { useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import {
//     testRunList,
//     testRunState,
// } from '../../../redux/testRun/testRunList.slice'
// import TestRunItem from './TestRunItem'
// import SkeletonTestRunList from './SkeletonTestRunList'
// import { useNavigate } from 'react-router-dom'
// import { getCurrentProjectId } from '../../../../sprints/components/testReport/testCases/forms/helper'

// // --- Helpers ---
// const formatDate = (d) =>
//     new Date(d).toLocaleDateString(undefined, {
//         year: 'numeric',
//         month: 'numeric',
//         day: 'numeric',
//     })

// // utils/computeProgress.js
// export function computeProgress(item, token) {
//     const total = Number(item?.total || 0)
//     const passed = Number(item?.passed || 0)
//     const failed = Number(item?.failed || 0)
//     const retest = Number(item?.retest || 0)
//     const pending = Number(item?.pending || 0)

//     const pct = (n) => (total ? (n / total) * 100 : 0)

//     const percents = {
//         pass: pct(passed),
//         fail: pct(failed),
//         retest: pct(retest),
//         pending: pct(pending),
//         completed: pct(passed + failed + retest),
//     }

//     // Keep overall strokeColor rules (optional)
//     let strokeColor = token?.colorPrimary
//     if (total === 0 || pending === total)
//         strokeColor = token?.colorTextQuaternary
//     if (failed > 0) strokeColor = token?.colorError
//     if (passed === total && total > 0) strokeColor = token?.colorSuccess

//     return { total, strokeColor, percents }
// }

// export default function TestRunList() {
//     const { token } = theme.useToken()

//     const dispatch = useDispatch()
//     const navigate = useNavigate()

//     const { testRun = {}, testRunListLoading = false } =
//         useSelector(testRunState)

//     const { data: testRunListData } = testRun

//     const [selectedIds, setSelectedIds] = useState([])

//     const toggleOne = (id, checked) => {
//         setSelectedIds((prev) =>
//             checked ? [...new Set([...prev, id])] : prev.filter((x) => x !== id)
//         )
//     }

//     const onEdit = (id) => {
//         navigate(`/dashboard/test-run/details/${id}`)
//     }

//     const onDelete = (id) => {
//         console.log('delete', id)
//         // call API then refresh list
//     }

//     const handleTestRunList = () => {
//         const payload = {
//             skip: 0,
//             limit: 10,
//             filter: {
//                 project: getCurrentProjectId(),
//             },
//         }

//         dispatch(testRunList(payload))
//     }

//     useEffect(() => {
//         handleTestRunList()
//     }, [])

//     return (
//         <div>
//             {/* Select all */}

//             {testRunListLoading && <SkeletonTestRunList />}
//             {!testRunListLoading && (
//                 <>
//                     <div style={{ padding: '8px 0 12px 4px' }}>
//                         <h5>Test Report List</h5>
//                         {/* <Checkbox
//                             indeterminate={indeterminate}
//                             checked={allChecked}
//                             onChange={(e) => toggleAll(e.target.checked)}
//                         >
//                             Select all
//                         </Checkbox> */}
//                     </div>
//                     <List
//                         style={{ maxHeight: '70vh', overflow: 'auto' }}
//                         dataSource={testRunListData}
//                         split={false}
//                         renderItem={(item) => {
//                             const { strokeColor, percents } = computeProgress(
//                                 item,
//                                 token
//                             )

//                             return (
//                                 <TestRunItem
//                                     selectedIds={selectedIds}
//                                     key={item._id}
//                                     item={item}
//                                     token={token}
//                                     toggleOne={toggleOne}
//                                     onDelete={onDelete}
//                                     onEdit={onEdit}
//                                     strokeColor={strokeColor}
//                                     percents={percents} // 👈 pass new object
//                                 />
//                             )
//                         }}
//                     />
//                 </>
//             )}
//         </div>
//     )
// }

// TestRunList.tsx
import { List, theme, Spin } from 'antd'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { testRunList } from '../../../redux/testRun/testRunList.slice'
import TestRunItem from './TestRunItem'
import SkeletonTestRunList from './SkeletonTestRunList'
import { useNavigate } from 'react-router-dom'
import { getCurrentProjectId } from '../../../../sprints/components/testReport/testCases/forms/helper'
import { apiGetTestRunList } from '../../../redux/testRun/testRun.service'

// --- Helpers ---
const formatDate = (d) =>
    new Date(d).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    })

// Progress util from your code
function computeProgress(item, token) {
    const total = Number(item?.total || 0)
    const passed = Number(item?.passed || 0)
    const failed = Number(item?.failed || 0)
    const retest = Number(item?.retest || 0)
    const pending = Number(item?.pending || 0)

    const pct = (n) => (total ? (n / total) * 100 : 0)

    const percents = {
        pass: pct(passed),
        fail: pct(failed),
        retest: pct(retest),
        pending: pct(pending),
        completed: pct(passed + failed + retest),
    }

    let strokeColor = token?.colorPrimary
    if (total === 0 || pending === total)
        strokeColor = token?.colorTextQuaternary
    if (failed > 0) strokeColor = token?.colorError
    if (passed === total && total > 0) strokeColor = token?.colorSuccess

    return { total, strokeColor, percents }
}

export default function TestRunList() {
    const { token } = theme.useToken()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    // ---- Local paging state ----
    const LIMIT = 10 // tweak as you like
    const [items, setItems] = useState([])
    const [skip, setSkip] = useState(0)
    const [loadingInitial, setLoadingInitial] = useState(true)
    const [loadingMore, setLoadingMore] = useState(false)
    const [isNext, setIsNext] = useState(true) // from API
    const [total, setTotal] = useState(null)

    const [selectedIds, setSelectedIds] = useState([])

    const listWrapRef = useRef(null)
    const sentinelRef = useRef(null)
    const observerRef = useRef(null)

    const toggleOne = (id, checked) => {
        setSelectedIds((prev) =>
            checked ? [...new Set([...prev, id])] : prev.filter((x) => x !== id)
        )
    }

    const onEdit = (id) => navigate(`/dashboard/test-run/details/${id}`)
    const onDelete = (id) => {
        // call API then refresh or remove locally
        console.log('delete', id)
    }

    const makePayload = useCallback(
        (nextSkip) => ({
            skip: nextSkip,
            limit: LIMIT,
            filter: { project: getCurrentProjectId() },
        }),
        []
    )

    // ---- Fetch page helper (returns page) ----
    const fetchPage = useCallback(
        async (nextSkip) => {
            const payload = makePayload(nextSkip)
            const res = await apiGetTestRunList(payload)
            const pageData = res?.data?.data || res?.data || []
            const pageIsNext = res?.data?.isNext ?? res?.isNext ?? false
            const pageTotal = res?.data?.total ?? res?.total ?? null
            return { pageData, pageIsNext, pageTotal }
        },
        [dispatch, makePayload]
    )

    // ---- Initial load ----
    useEffect(() => {
        let mounted = true
        ;(async () => {
            try {
                setLoadingInitial(true)
                const { pageData, pageIsNext, pageTotal } = await fetchPage(0)
                if (!mounted) return
                setItems(pageData || [])
                setIsNext(Boolean(pageIsNext))
                if (pageTotal != null) setTotal(pageTotal)
                setSkip(pageData?.length || 0)
            } finally {
                if (mounted) setLoadingInitial(false)
            }
        })()
        return () => {
            mounted = false
        }
    }, [fetchPage])

    // ---- Load more (called by observer) ----
    const loadMore = useCallback(async () => {
        if (loadingMore || loadingInitial || !isNext) return
        try {
            setLoadingMore(true)
            const { pageData, pageIsNext } = await fetchPage(skip)
            setItems((prev) => [...prev, ...(pageData || [])])
            setIsNext(Boolean(pageIsNext))
            setSkip((prev) => prev + (pageData?.length || 0))
        } finally {
            setLoadingMore(false)
        }
    }, [fetchPage, isNext, loadingInitial, loadingMore, skip])

    // ---- IntersectionObserver to trigger loadMore ----
    useEffect(() => {
        if (!listWrapRef.current || !sentinelRef.current) return

        observerRef.current?.disconnect()
        observerRef.current = new IntersectionObserver(
            (entries) => {
                const entry = entries[0]
                if (entry.isIntersecting) {
                    loadMore()
                }
            },
            {
                root: listWrapRef.current, // observe within the scroll container
                rootMargin: '0px 0px 200px 0px', // prefetch when ~200px away
                threshold: 0.01,
            }
        )

        observerRef.current.observe(sentinelRef.current)

        return () => {
            observerRef.current?.disconnect()
        }
    }, [loadMore, items.length]) // reattach if list changes height

    return (
        <div>
            <div style={{ padding: '8px 0 12px 4px' }}>
                <h5>Test Report List</h5>
            </div>

            {loadingInitial ? (
                <SkeletonTestRunList />
            ) : (
                <div
                    ref={listWrapRef}
                    style={{
                        maxHeight: '70vh',
                        overflow: 'auto',
                        // border: '1px solid #f0f0f0',
                        // borderRadius: 8,
                    }}
                >
                    <List
                        dataSource={items}
                        split={false}
                        renderItem={(item) => {
                            const { strokeColor, percents } = computeProgress(
                                item,
                                token
                            )
                            return (
                                <TestRunItem
                                    selectedIds={selectedIds}
                                    key={item._id}
                                    item={item}
                                    token={token}
                                    toggleOne={toggleOne}
                                    onDelete={onDelete}
                                    onEdit={onEdit}
                                    strokeColor={strokeColor}
                                    percents={percents}
                                />
                            )
                        }}
                    />

                    {/* Sentinel for infinite loading */}
                    <div ref={sentinelRef} />

                    {/* Loader / End indicator */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '12px 0',
                        }}
                    >
                        {loadingMore ? (
                            <Spin size="small" />
                        ) : !isNext && items?.length > 10 ? (
                            <span style={{ color: '#999' }}>
                                No more reports
                            </span>
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    )
}
